import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import navigationEn from './local/en/navigation';
import navigationFr from './local/fr/navigation';
import navigationZh from './local/zh/navigation';

const resources = {
  en: {
    navigation: navigationEn
  },
  fr: {
    navigation: navigationFr
  },
  zh: {
    navigation: navigationZh
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: 'fr',
    fallbackLng: 'fr',
    debug: false,
    resources,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
